import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import {filter} from 'rxjs/operators';
import {
  DocumentSearchService,
  DocumentsTableComponent,
  DocumentView,
  FileDetailService,
  isAuthorizedOperationGranted
} from '|shared';
import {FileDetailContentDatasource} from './file-detail-content.datasource';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {FileAuthorizedOperation} from '|api/core';
import {Router} from '@angular/router';
import {ButtonComponent, WaitingDirective, LabelComponent, LoadingIndicatorService} from '@icz/angular-essentials';
import {ApiSettlementService} from '|api/document';
import {of} from 'rxjs';
import {AsyncPipe} from '@angular/common';
import {ApplicationRoute, createAbsoluteRoute, DocumentsRoute} from '|ui-essl-core';


@Component({
  selector: 'icz-file-detail-content',
  templateUrl: './file-detail-content.component.html',
  styleUrls: ['./file-detail-content.component.scss'],
  imports: [WaitingDirective, DocumentsTableComponent, LabelComponent, ButtonComponent, AsyncPipe]
})
export class FileDetailContentComponent implements OnInit {

  protected loadingService = inject(LoadingIndicatorService);
  private apiSettlementService = inject(ApiSettlementService);
  private fileDetailService = inject(FileDetailService);
  private searchService = inject(DocumentSearchService);
  private destroyRef = inject(DestroyRef);
  private router = inject(Router);

  dataSource!: FileDetailContentDatasource;
  documentsListingPermissionGranted = true;

  private currentFileId!: number;

  readonly DocumentView = DocumentView;

  ngOnInit() {
    this.fileDetailService.showSubmitBar = false;

    this.fileDetailService.object$.pipe(
      filter(Boolean),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(file => {
      const fileId = file.id;

      if (fileId !== this.currentFileId) {
        this.documentsListingPermissionGranted = isAuthorizedOperationGranted(file!.authorization, FileAuthorizedOperation.FILE_SHOW_DOCUMENTS);
        this.currentFileId = fileId;

        const settlement$ = (
          file.settlementId ?
            this.apiSettlementService.settlementFindById({
              id: file.settlementId
            }) :
            of(null)
        );

        this.loadingService.doLoading(
          settlement$,
          this,
        ).subscribe(settlement => {
          this.dataSource = new FileDetailContentDatasource(
            this.searchService,
            file,
            settlement,
            !isAuthorizedOperationGranted(file.authorization, FileAuthorizedOperation.FILE_SHOW_PROFILE)
          );
        });
      }
      else {
        this.dataSource.reload(true);
      }
    });
  }

  goToCreateDocument(forOwnDocument: boolean) {
    const url = createAbsoluteRoute(ApplicationRoute.DOCUMENTS, DocumentsRoute.FILE, this.currentFileId, forOwnDocument ? DocumentsRoute.OWN_DOCUMENT_TO_FILE : DocumentsRoute.RECEIVED_DOCUMENT_TO_FILE);
    this.router.navigateByUrl(url);
  }

}
